import React from 'react'
import Image from '/js/views/shared/components/contentParticles/image'

class HighlightText extends React.Component {
  renderList() {
    const { list } = this.props.content.texts

    if (!list) {
      return null
    }

    return (
      <ul>
        {list.map((item, index) => {
          return (
            <li key={`li-${index}`}>
              <span className="font-bold">{item.title}</span>: {item.content}
            </li>
          )
        })}
      </ul>
    )
  }

  renderBody() {
    const { body } = this.props.content.texts

    if (!body) {
      return null
    }

    return <p className="text-18 leading-normal font-bold">{body}</p>
  }

  renderImage() {
    const { content } = this.props

    if (!content.images) {
      return null
    }

    return (
      <div className="max-w-150 mx-auto">
        <Image images={content.images} highlight={true} />
      </div>
    )
  }
  render() {
    const { content, theme } = this.props

    return (
      <div className="text-center w-full" data-label="highlight-text">
        {this.renderImage()}
        <p
          className={`divider text-18 font-condensed uppercase pb-15 mb-15 ${theme.textColor}`}
        >
          {content.texts.title}
        </p>
        {this.renderBody()}
        {this.renderList()}
      </div>
    )
  }
}

export default HighlightText
